import { prettyPrintEnumValue } from "../utils/prettyPrintEnumValue";

// String keys let the Prisma and generated GraphQL enums share these labels.
export const NOT_REPORTING_REASON_LABEL: Record<string, string> = {
  OUT_OF_CONTRACT_SCOPE: "Out of contract scope",
  NOT_APPLICABLE_TO_ACTIVITY: "Not applicable to facility activity",
  OTHER: "Other",
};

export function getNotReportingReasonLabel(reason: string): string {
  return NOT_REPORTING_REASON_LABEL[reason] ?? prettyPrintEnumValue(reason, [], true);
}

export function getNotReportingReasonText(reason: string, note?: string | null): string {
  const label = getNotReportingReasonLabel(reason);
  const trimmedNote = note?.trim();
  if (trimmedNote) {
    return `${label}: ${trimmedNote}`;
  }
  return label;
}

export function formatNotReportingReason(
  reason?: string | null,
  note?: string | null
): string | null {
  if (!reason) {
    return null;
  }
  return getNotReportingReasonText(reason, note);
}
